export default {
  'wirePayment.title': '<%= type %> Wire Payment',
  'wirePayment.originator': 'Originator Information',
  'wirePayment.beneficiary': 'Beneficiary Information',
  'wirePayment.line': 'Address Line <%= line %>',
  'wirePayment.review': 'Review and submit to complete payment',
  'wirePayment.missingBankCode': 'Missing Bank Code',
  'wirePayment.missingBankName': 'Missing Bank Name',
  'wirePayment.foreignAmount': 'Foreign Amount',
  'wire.physicalAddress': 'Physical Address Required. No P.O. Box Address',
  'wire.insufficientFunds': 'Insufficient Funds',
  'wire.rateNotFinal': 'Rate may not be final',
  'wire.exchangeRate': 'Exchange Rate',
  'wire.line': 'Line'
};
